import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxStripeModule } from 'ngx-stripe';
import { PaymentFormComponent } from './payment-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgxStripeModule.forChild(),
        ReactiveFormsModule,
        TranslateModule
    ],
    declarations: [PaymentFormComponent],
    exports: [PaymentFormComponent]
})
export class PaymentFormComponentsModule { }